import { c as _c } from "react/compiler-runtime";
import { ApiGroupOwnsNft, ApiGroupOwnsNftNameEnum } from "@/generated/models/ApiGroupOwnsNft";
import GroupCreateNftsSelectedItem from "./GroupCreateNftsSelectedItem";
export default function GroupCreateNftsSelected(t0) {
  const $ = _c(7);
  const {
    selected,
    onRemove
  } = t0;
  let t1;
  if ($[0] !== onRemove || $[1] !== selected) {
    let t2;
    if ($[3] !== onRemove) {
      t2 = group => group.tokens.map(token => <GroupCreateNftsSelectedItem key={`${group.name}-${token}`} nft={{
        name: group.name,
        token
      }} onRemove={() => onRemove({
        name: group.name,
        token
      })} />);
      $[3] = onRemove;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = selected.flatMap(t2);
    $[0] = onRemove;
    $[1] = selected;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="tw-flex tw-flex-wrap tw-gap-2 tw-mt-3">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}